import React from 'react';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { alpha } from '@mui/material/styles';

import Iconify from '../../theme/iconify/iconify';

function TOC({ tab, config, handleTOC, disabled }) {
    return (
        <Tabs
            orientation='vertical'
            value={tab}
            onChange={handleTOC}
            className='mISLec_course_toc'
            sx={{
                borderLeft: (theme) => `solid 1px ${theme.palette.divider}`,
                "& .MuiTabs-indicator": { display: 'none' }
            }}
        >
            {config.map((item, section) => {
                return (
                    [
                        <Tab
                            label={item.label.toUpperCase()}
                            key={`mISLec_section_${section}`}
                            value={`${section}`}
                            className='mISLec_course_toc_section'
                            disabled={tab === `${section}` ? false : disabled}
                            sx={{
                                textAlign: 'left',
                                borderRadius: '0 8px 8px 0',
                                minHeight: 24,
                                paddingTop: 1,
                                paddingBottom: 1,
                                borderLeft: tab === `${section}` ? (theme) => `solid 2px ${theme.palette.primary.main}` : 'none',
                                backgroundColor: tab === `${section}` ? (theme) => alpha(theme.palette.primary.main, 0.08) : 'inherit',
                                ':hover': {
                                    backgroundColor: tab === `${section}` ? (theme) => alpha(theme.palette.primary.main, 0.16) : 'rgba(145, 158, 171, 0.08)'
                                }
                            }}
                        />,
                        item.active && item.subsections.map((subsection) => (
                            <Tab
                                label={subsection.label}
                                key={`mISLec_subsection_${subsection.id}`}
                                value={`${section}_${subsection.id}`}
                                disabled={tab === `${section}` ? false : disabled}
                                icon={<Iconify icon='majesticons:text' width={16} height={16} />}
                                sx={{
                                    textAlign: 'left',
                                    borderRadius: '0 8px 8px 0',
                                    minHeight: 24,
                                    paddingTop: 1,
                                    paddingBottom: 1,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'left',
                                    alignContent: 'center',
                                    borderLeft: tab === `${section}_${subsection.id}` ? (theme) => `solid 2px ${theme.palette.primary.main}` : 'none',
                                    backgroundColor: tab === `${section}_${subsection.id}` ? (theme) => alpha(theme.palette.primary.main, 0.08) : 'inherit',
                                    ':hover': {
                                        backgroundColor: tab === `${section}_${subsection.id}` ? (theme) => alpha(theme.palette.primary.main, 0.16) : 'rgba(145, 158, 171, 0.08)'
                                    }
                                }}
                            />
                        ))
                    ]
                );
            })}
        </Tabs>
    );
}

export default TOC;